import React from "react";
import { Routes, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

import { StudentAuthProvider } from "./context/StudentAuthContext";
import { PanelAuthProvider } from "./context/PanelAuthContext";
import { AdminAuthProvider } from "./context/AdminAuthContext";
import RequireStudent from "./routes/RequireStudent";
import RequirePanel from "./routes/RequirePanel";
import RequireAdmin from "./routes/RequireAdmin";

import CampusHiring from "./pages/CampusHiring";
import AdminLayout from "./components/layout/AdminLayout";
import AdminLogin from "./pages/AdminLogin";
import CampusDashboard from "./pages/CampusDashboard";
import Universities from "./pages/Universities";
import UniversityDetails from "./pages/UniversityDetails";
import Students from "./pages/Students";
import StudentDetails from "./pages/StudentDetails";
import Settings from "./pages/Settings";
import RoundsManagement from "./pages/RoundsManagement";
import PanelUsersAdmin from "./pages/PanelUsersAdmin";
import HiringFunnel from "./pages/HiringFunnel";

import StudentLogin from "./pages/student/StudentLogin";
import StudentForgotPassword from "./pages/student/StudentForgotPassword";
import StudentSignup from "./pages/student/StudentSignup";
import StudentVerifyOtp from "./pages/student/StudentVerifyOtp";
import StudentDashboard from "./pages/student/StudentDashboard";
import StudentApplicationDetail from "./pages/student/StudentApplicationDetail";

import PanelLogin from "./pages/panel/PanelLogin";
import PanelDashboard from "./pages/panel/PanelDashboard";
import PanelRoundReview from "./pages/panel/PanelRoundReview";
import PanelStudentDetail from "./pages/panel/PanelStudentDetail";

export default function App() {
  return (
    <StudentAuthProvider>
      <PanelAuthProvider>
        <AdminAuthProvider>
          <AnimatePresence mode="wait">
            <Routes>
              <Route path="/" element={<CampusHiring />} />

              {/* Student portal */}
              <Route path="/student/login" element={<StudentLogin />} />
              <Route path="/student/forgot-password" element={<StudentForgotPassword />} />
              <Route path="/student/signup" element={<StudentSignup />} />
              <Route
                path="/student/verify-otp"
                element={<StudentVerifyOtp />}
              />
              <Route element={<RequireStudent />}>
                <Route
                  path="/student/dashboard"
                  element={<StudentDashboard />}
                />
                <Route
                  path="/student/applications/:id"
                  element={<StudentApplicationDetail />}
                />
              </Route>

              {/* Interview panel portal */}
              <Route path="/panel/login" element={<PanelLogin />} />
              <Route element={<RequirePanel />}>
                <Route path="/panel" element={<PanelDashboard />} />
                <Route
                  path="/panel/rounds/:roundId"
                  element={<PanelRoundReview />}
                />
                <Route
                  path="/panel/rounds/:roundId/students/:studentId"
                  element={<PanelStudentDetail />}
                />
              </Route>

              {/* Admin console — /admin/login is public, everything else requires an admin session */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route element={<RequireAdmin />}>
                <Route path="/admin" element={<AdminLayout />}>
                  <Route index element={<CampusDashboard />} />
                  <Route path="universities" element={<Universities />} />
                  <Route
                    path="universities/:id"
                    element={<UniversityDetails />}
                  />
                  <Route
                    path="universities/:id/rounds"
                    element={<RoundsManagement />}
                  />
                  <Route path="students" element={<Students />} />
                  <Route path="students/:id" element={<StudentDetails />} />
                  <Route path="panel-users" element={<PanelUsersAdmin />} />
                  <Route path="funnel" element={<HiringFunnel />} />
                  <Route path="settings" element={<Settings />} />
                </Route>
              </Route>

              <Route path="*" element={<NotFound />} />
            </Routes>
          </AnimatePresence>
        </AdminAuthProvider>
      </PanelAuthProvider>
    </StudentAuthProvider>
  );
}

function NotFound() {
  return (
    <div
      style={{
        padding: "80px 24px",
        textAlign: "center",
        fontFamily: "Inter, sans-serif",
      }}
    >
      <h1>404</h1>
      <p>That page doesn't exist.</p>
    </div>
  );
}
